import React from 'react';
import css from "./Calendars.module.css";

const EmptyDay = props => <div className={css.emptyDay} />;

export default EmptyDay;